module.exports = __webpack_public_path__ + "img/bx-9.10310da3.jpg";